import FInput_PinyinSafeTextCounter from '@/components/FInput_PinyinSafeTextCounter';
import FComponentsLib from '@freelog/components-lib';
import { DatePicker, Radio } from 'antd';
// import img_idCardBack from './idCardBack.png';
// import img_idCardFront from './idCardFront.png';
import styles from './index.less';
import { FI18n, FServiceAPI, FUtil } from '@freelog/tools-lib';
// import fReadLocalFiles from '@/components/fReadLocalFiles';
import fMessage from '@/components/fMessage';
import FBindPhoneModal from '@/components/FBindPhoneModal';
import * as AHooks from 'ahooks';
import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';

dayjs.extend(customParseFormat);
import { history, useParams } from 'umi';
import FAuthenticationModal from '@/components/FAuthenticationModal';
import FidPhotoUpload from '@/components/FIdPhotoUpload';

const { RangePicker } = DatePicker;

interface SettlementInfoProps {}

interface SettlementInfo {
  info: {
    region: string;
    entityType: 'individuals';
    // | 'businesses';
    realName: string;
    idNumber: string;
  };
  formData: {
    realName: string;
    idNumber: string;
    idCardFront: string;
    idCardFrontImage: string;
    idCardBack: string;
    idCardBackImage: string;
    idType: 'short' | 'long';
    idPeriodStart: dayjs.Dayjs | null;
    idPeriodEnd: dayjs.Dayjs | null;
  };
}

const initVal: SettlementInfo = {
  info: {
    region: FI18n.i18nNext.t('payout_setting_region_input_option_chinamainland'),
    entityType: 'individuals',
    realName: '',
    idNumber: '',
  },
  formData: {
    realName: '',
    idNumber: '',
    idCardFront: '',
    idCardFrontImage: '',
    idCardBack: '',
    idCardBackImage: '',
    idType: 'short',
    idPeriodStart: null,
    idPeriodEnd: null,
  },
};

function SettlementInfo(_props: SettlementInfoProps) {
  const params = useParams<{ id: string }>();
  const [$nowData, set$nowData, get$nowData] = FUtil.Hook.useGetState<dayjs.Dayjs>(
    dayjs().startOf('day'),
  );
  // console.log($nowData, 'si8fjl;dkjfl;kjl;k');

  const [$info, set$Info, get$Info] = FUtil.Hook.useGetState<SettlementInfo['info']>(initVal.info);
  const [$formData, set$FormData, get$FormData] = FUtil.Hook.useGetState<
    SettlementInfo['formData']
  >(initVal.formData);

  const [$showModal, set$showModal, get$showModal] = FUtil.Hook.useGetState<boolean>(false);

  const [$showAuthenticationModal, set$showAuthenticationModal, get$showAuthenticationModal] =
    FUtil.Hook.useGetState<boolean>(true);

  AHooks.useMount(async () => {
    const {
      ret,
      errCode,
      msg,
      data,
    }: {
      ret: number;
      errCode: number;
      msg: string;
      data: {
        accountType: 1;
        availableBalance: number;
        certName: string;
        certNo: string;
        createDate: string;
        currencyType: number;
        freezeBalance: number;
        id: string;
        ownerId: number;
        ownerName: string;
        ownerUserId: number;
        ownerUserName: string;
        status: number;
        totalBalance: number;
        certBeginDate: string;
        certEndDate: string;
      };
    } = await FServiceAPI.Payment.queryFinancialAccountInfo2({
      accountId: params.id!,
    });
    if (ret !== 0 || errCode !== 0) {
      fMessage(msg, 'error');
      return;
    }

    set$Info({
      ...get$Info(),
      realName: data.certName,
      idNumber: data.certNo,
    });

    set$FormData({
      ...get$FormData(),
      realName: data.certName,
      idNumber: data.certNo,
      idType: data.certEndDate ? 'short' : 'long',
      idPeriodStart: dayjs(data.certBeginDate, 'YYYY-MM-DD'),
      idPeriodEnd: dayjs(data.certEndDate, 'YYYY-MM-DD'),
    });
  });

  return (
    <>
      <div className={styles.settlementInfoContainer}>
        <div className={styles.headerSection}>
          <h2 className={styles.title}>
            {
              // 修改身份证期限
              FI18n.i18nNext.tAuto('payout_setting_entity_title2')
            }
          </h2>
        </div>

        <div className={styles.section}>
          <div>
            <div className={styles.sectionTitle}>
              {
                // 认证信息
                FI18n.i18nNext.tAuto('payout_setting_entity_title')
              }
            </div>
            <div style={{ height: 5 }} />
            <FComponentsLib.FContentText
              type='additional1'
              text={
                // 个人认证信息需要和银行卡持有人保持一致，身份证信息提交后不可修改，请谨慎提交
                FI18n.i18nNext.tAuto('payout_setting_entity_info')
              }
            />
          </div>

          <div className={styles.fieldGroup}>
            <div className={styles.fieldLabel}>
              {
                // 身份证照片
                FI18n.i18nNext.tAuto('payout_setting_entity_input_idphoto')
              }
            </div>
            <FidPhotoUpload
              onFrontSuccess={(data) => {
                set$FormData({
                  ...get$FormData(),
                  idCardFront: data.certImagePath,
                  realName: data.name,
                  idNumber: data.idNumber,
                });
              }}
              onBackSuccess={(data) => {
                const validPeriod = data.validPeriod;
                const [start, end] = validPeriod.split('-');
                const idPeriodStart: dayjs.Dayjs = dayjs(start, 'YYYY.MM.DD');
                const idPeriodEnd: dayjs.Dayjs | null =
                  end === '长期' ? null : dayjs(end, 'YYYY.MM.DD');
                const idType: 'long' | 'short' = !idPeriodEnd ? 'long' : 'short';
                set$FormData({
                  ...get$FormData(),
                  idCardBack: data.certImagePath,
                  idPeriodStart: get$FormData().idPeriodStart
                    ? get$FormData().idPeriodStart
                    : idPeriodStart,
                  idPeriodEnd: get$FormData().idPeriodStart
                    ? get$FormData().idPeriodEnd
                    : idPeriodEnd,
                  idType: get$FormData().idPeriodStart ? get$FormData().idType : idType,
                });
              }}
            />
            <div className={styles.photoHint}>
              {
                // 正面拍摄、清晰、四角完整、无反光或遮挡；不得翻拍、截图、镜像、PS。
                FI18n.i18nNext.tAuto('payout_setting_entity_input_idphoto_info3')
              }
              {/* <div>•&nbsp;

              </div> */}
              {/* <div>
                •&nbsp;
                {
                  // 彩色照片or彩色扫描件，复印件需加盖公章鲜章，可添加"Freelog认证"相关水印。
                  FI18n.i18nNext.tAuto('payout_setting_entity_input_idphoto_info4')
                }
              </div> */}
            </div>
          </div>

          <div className={styles.fieldGroup}>
            <div className={styles.fieldLabel}>
              {
                // 真实姓名
                FI18n.i18nNext.tAuto('payout_setting_entity_input_name')
              }
            </div>
            <FInput_PinyinSafeTextCounter
              lengthLimit={-1}
              disabled
              value={$info.realName}
              // onChangeValue={(value) => handleInputChange('realName', value)}
              // placeholder='请输入内容...'
              // className={styles.input}
              style={{ width: '100%' }}
            />
          </div>

          <div className={styles.fieldGroup}>
            <div className={styles.fieldLabel}>
              {
                // 身份证号
                FI18n.i18nNext.tAuto('payout_setting_entity_input_idno')
              }
            </div>
            <FInput_PinyinSafeTextCounter
              lengthLimit={-1}
              disabled
              value={$info.idNumber}
              // placeholder='请输入内容...'
              style={{ width: '100%' }}
            />
          </div>

          <div className={styles.fieldGroup}>
            <div className={styles.fieldLabel}>
              {
                // 身份证期限
                FI18n.i18nNext.tAuto('payout_setting_entity_input_idvalidation')
              }
            </div>
            <div className={styles.idPeriodContainer}>
              <div className={styles.radioGroup}>
                <Radio.Group
                  value={$formData.idType}
                  onChange={(e) => {
                    set$FormData({
                      ...get$FormData(),
                      idType: e.target.value,
                      idPeriodStart: null,
                      idPeriodEnd: null,
                    });
                  }}
                  className={styles.radioButtons}
                >
                  <Radio value='short'>
                    {
                      // 短期
                      FI18n.i18nNext.tAuto('payout_setting_entity_input_idvalidation_option')
                    }
                  </Radio>
                  <Radio value='long'>
                    {
                      // 长期
                      FI18n.i18nNext.tAuto('payout_setting_entity_input_idvalidation_option2')
                    }
                  </Radio>
                </Radio.Group>
              </div>
              <div style={{ height: 10 }} />
              <div className={styles.dateRangeWrapper}>
                {$formData.idType === 'long' ? (
                  <div className={styles.dateRangeWrapper}>
                    <DatePicker
                      style={{ height: 38 }}
                      placeholder={
                        // 开始时间
                        FI18n.i18nNext.t('payout_setting_entity_input_idvalidation_hint')
                      }
                      value={$formData.idPeriodStart}
                      onChange={(date) => {
                        // handleInputChange('idPeriodStart', date);
                        set$FormData({
                          ...get$FormData(),
                          idPeriodStart: date ?? null,
                        });
                      }}
                      disabledDate={(date) => {
                        return date.isBefore(dayjs('1900-01-01')) || date.isAfter(get$nowData());
                      }}
                    />
                  </div>
                ) : (
                  <RangePicker
                    value={[$formData.idPeriodStart, $formData.idPeriodEnd]}
                    onChange={(dates) => {
                      set$FormData({
                        ...get$FormData(),
                        idPeriodStart: dates?.[0] ?? null,
                        idPeriodEnd: dates?.[1] ?? null,
                      });
                    }}
                    placeholder={[
                      // 开始时间
                      FI18n.i18nNext.t('payout_setting_entity_input_idvalidation_hint'),
                      // 结束时间
                      FI18n.i18nNext.t('payout_setting_entity_input_idvalidation_hint2'),
                    ]}
                    className={styles.dateRange}
                    disabledDate={(date) => {
                      return date.isBefore(dayjs('1900-01-01')) || date.isAfter(get$nowData());
                    }}
                  />
                )}
              </div>
            </div>
          </div>
        </div>

        <div className={styles.submitSection}>
          <FComponentsLib.FRectBtn
            disabled={!$formData.idCardFront || !$formData.idCardBack || !$formData.idPeriodStart}
            type='primary'
            onClick={async () => {
              const {
                idNumber,
                realName,
                idCardFront,
                idCardBack,
                idPeriodStart,
                idPeriodEnd,
                idType,
              } = get$FormData();
              const params: Parameters<typeof FServiceAPI.Payment.updateFinancialAccount>[0] = {
                accountId: params.id!,
                certNo: idNumber.trim(),
                name: realName.trim(),
                certValidityType: idType === 'long' ? 1 : 0,
                certBeginDate: idPeriodStart?.format(FUtil.Predefined.momentDateFormat) ?? '',
                certEndDate: idPeriodEnd?.format(FUtil.Predefined.momentDateFormat) || undefined,
                certImagePaths: [idCardFront, idCardBack],
              };
              const {
                ret,
                errCode,
                msg,
                data,
              }: { ret: number; errCode: number; msg: string; data: { id: string } } =
                await FServiceAPI.Payment.updateFinancialAccount(params);
              if (ret !== 0 || errCode !== 0) {
                fMessage(msg, 'error');
                return;
              }

              fMessage('提交成功', 'success');
              history.push(
                FUtil.LinkTo.settlementInfo({
                  accountID: params.id!,
                }),
              );
            }}
          >
            {
              // 提交
              FI18n.i18nNext.tAuto('payout_setting_entity_btn_submit')
            }
          </FComponentsLib.FRectBtn>
        </div>
      </div>

      <FBindPhoneModal
        open={$showModal}
        onOk={(phone) => {
          set$showModal(false);
          // handleInputChange('mobileNumber', phone);
        }}
      />

      <FAuthenticationModal
        open={$showAuthenticationModal}
        onOk={() => {
          set$showAuthenticationModal(false);
        }}
      />
    </>
  );
}

export default SettlementInfo;
